import React, { useEffect, useState } from "react";
import BreakOutBoxImage from "../../../assets/images/Defence/Products/BreakOutBox.png";

//  BREAKOUT BOX – SECTION COMPONENT (NO CONFLICT DESIGN)
const BreakOutBox = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /*  GMAIL ENQUIRY HANDLER (BREAKOUT BOX) */
  const handleMail = () => {
    const email = "sales@combatsolutions.ai";   //  Receiver
    const subject = "Enquiry – Discrete & Synchro/Resolver Signal Breakout Box";

    const body = `Hello Combat Solutions Team,

I am interested in receiving the technical specifications for the Discrete & Synchro/Resolver Signal Breakout Box.

Product: Discrete & Synchro/Resolver Signal Breakout Box

Company Name:
Designation:
Contact Number:
Application / Platform:

Additional Requirements / Questions:


Regards,
`;

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
      email
    )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.open(gmailUrl, "_blank");
  };

  //  BREAKOUT BOX – STYLE NAMESPACE (SAFE & ISOLATED)
  const breakStyles = {
    breakSection: {
      width: "100%",
      padding: isMobile ? "40px 24px" : "60px 60px",
      backgroundColor: "#ffffff",
    },

    breakContainer: {
      display: "flex",
      flexDirection: isMobile ? "column-reverse" : "row",
      gap: isMobile ? "40px" : "80px",
      alignItems: "center",
      justifyContent: "space-between",
      maxWidth: "1400px",
      margin: "0 auto",
    },

    /* LEFT CONTENT */
    breakContent: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: isMobile ? "center" : "flex-start",
    },

    breakBadge: {
      display: "inline-block",
      backgroundColor: "#fff2e6",
      color: "#ff7a00",
      padding: "6px 14px",
      borderRadius: "20px",
      fontSize: "12px",
      fontWeight: 600,
      marginBottom: "18px",
      alignSelf: isMobile ? "center" : "flex-start",
    },

    breakTitle: {
      fontSize: isMobile ? "26px" : "36px",
      fontWeight: 700,
      color: "#0f172a",
      marginBottom: "18px",
      lineHeight: 1.3,
      textAlign: isMobile ? "center" : "left",
    },

    breakDescription: {
      fontSize: isMobile ? "14px" : "16px",
      color: "#64748b",
      lineHeight: 1.7,
      marginBottom: "36px",
      maxWidth: "560px",
      textAlign: isMobile ? "center" : "left",
    },

    /* FEATURE CARDS */
    breakFeatureBox: {
      border: "1px solid #e5e7eb",
      borderRadius: "14px",
      padding: isMobile ? "18px" : "22px",
      marginBottom: "18px",
      backgroundColor: "#ffffff",
      width: "100%",
      maxWidth: isMobile ? "420px" : "100%",
    },

    breakFeatureTitle: {
      fontSize: "16px",
      fontWeight: 600,
      color: "#0f172a",
      marginBottom: "6px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      justifyContent: isMobile ? "center" : "flex-start",
      textAlign: isMobile ? "center" : "left",
    },

    breakFeatureIcon: {
      color: "#ff7a00",
      fontSize: "20px",
    },

    breakFeatureText: {
      fontSize: "14px",
      color: "#64748b",
      lineHeight: 1.6,
      textAlign: isMobile ? "center" : "left",
    },

    breakButton: {
      marginTop: "30px",
      backgroundColor: "#ffffff",
      color: "#ff7a00",
      padding: "14px 28px",
      border: "2px solid #ff7a00",
      borderRadius: "30px",
      fontSize: "14px",
      fontWeight: 600,
      cursor: "pointer",
      transition: "all 0.3s ease",
      alignSelf: isMobile ? "center" : "flex-start",
    },

    /* RIGHT IMAGE */
    breakImageBox: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    breakMainImage: {
      width: "100%",
      maxWidth: isMobile ? "320px" : "560px",
      objectFit: "contain",
    },
  };

  return (
    <section style={breakStyles.breakSection}>
      <div style={breakStyles.breakContainer}>

        {/* LEFT CONTENT */}
        <div style={breakStyles.breakContent}>
          <span style={breakStyles.breakBadge}>TEST & VALIDATION</span>

          <h2 style={breakStyles.breakTitle}>
            Discrete & Synchro/Resolver <br /> Signal Breakout Box
          </h2>

          <p style={breakStyles.breakDescription}>
            Comprehensive signal testing solution for weapon and fire-control
            systems. Provides access to critical signals for validation,
            debugging, and field diagnostics.
          </p>

          {/* FEATURE 1 */}
          <div style={breakStyles.breakFeatureBox}>
            <div style={breakStyles.breakFeatureTitle}>
              <i
                className="bi bi-lightning-charge-fill"
                style={breakStyles.breakFeatureIcon}
              ></i>
              Signal Testing
            </div>
            <p style={breakStyles.breakFeatureText}>
              Front panel access to discrete, synchro, and resolver signals for
              comprehensive system validation
            </p>
          </div>

          {/* FEATURE 2 */}
          <div style={breakStyles.breakFeatureBox}>
            <div style={breakStyles.breakFeatureTitle}>
              <i
                className="bi bi-shield-fill-check"
                style={breakStyles.breakFeatureIcon}
              ></i>
              Weapon & Fire-Control Systems
            </div>
            <p style={breakStyles.breakFeatureText}>
              Specifically designed for weapon control electronics and
              fire-control system integration
            </p>
          </div>

          {/* FEATURE 3 */}
          <div style={breakStyles.breakFeatureBox}>
            <div style={breakStyles.breakFeatureTitle}>
              <i
                className="bi bi-bullseye"
                style={breakStyles.breakFeatureIcon}
              ></i>
              Defence Test Benches
            </div>
            <p style={breakStyles.breakFeatureText}>
              Essential tool for HATS, SATS, and field commissioning activities
            </p>
          </div>

          {/*  GMAIL TRIGGER BUTTON */}
          <button style={breakStyles.breakButton} onClick={handleMail}>
            Request Technical Specifications
          </button>
        </div>

        {/* RIGHT IMAGE */}
        <div style={breakStyles.breakImageBox}>
          <img
            src={BreakOutBoxImage}
            alt="Breakout Box"
            style={breakStyles.breakMainImage}
          />
        </div>
      </div>
    </section>
  );
};

export default BreakOutBox;
